import { IdentifiedItemType, AttackWeaponsCategory, ModDomain, LifeArmourCategory, EnergyShieldArmourCategory, CasterWeaponsCategory, GemWeaponsCategory, QuiversCategory, JewelleryCategory, JewelsCategory, AbyssJewelsCategory, TimeLostJewelsCategory } from "../../models/enums";
import { ModItemCategory } from "../../models/item-data-models";

export const modItemCategories: ModItemCategory[] = [
  {
    type: IdentifiedItemType.AttackWeapons,
    category: AttackWeaponsCategory.MeleePhysical,
    domain: ModDomain.Equipment,
    name: 'Physical Attack Weapons',
    tags: ['physical_damage', 'physical', 'critical', 'speed', 'attack'],
    excludeTags: ['caster_damage', 'caster'],
    badTags: ['chaos'],
    slots: ['weapon', 'sword', 'axe', 'mace', 'rapier', 'claw', 'dagger', 'one_hand_weapon', 'two_hand_weapon'],
    excludeSlots: [],
    includePerfectModTypes: ['LocalAddedPhysicalDamage', 'LocalIncreasedPhysicalDamagePercent', 'LocalIncreasedAttackSpeed', 'LocalCriticalStrikeChance'],
    includeGreatModTypes: [],
    includeGoodModTypes: ['LocalAddedFireDamage', 'LocalAddedFireDamageTwoHand', 'LocalAddedColdDamage', 'LocalAddedColdDamageTwoHand', 'LocalAddedLightningDamage', 'LocalAddedLightningDamageTwoHand', 'WeaponElementalDamage', 'WeaponElementalDamageOnTwohandWeapon', 'ManaLeechLocal', 'LifeLeechLocal'],
    excludeModTypes: ['LocalLightRadiusAndAccuracy', 'LocalIncreasedAccuracy'],
  },
  // {
  //   type: IdentifiedItemType.AttackWeapons,
  //   category: AttackWeaponsCategory.MeleeElemental,
  //   domain: ModDomain.Equipment,
  //   name: 'Elemental Attack Weapons',
  //   tags: ['elemental_damage', 'speed', 'critical'],
  //   excludeTags: ['caster', 'chaos'],
  //   badTags: ['physical', 'physical_damage', 'chaos'],
  //   slots: ['weapon', 'sword', 'axe', 'mace', 'rapier', 'claw', 'dagger', 'one_hand_weapon', 'two_hand_weapon'],
  //   excludeSlots: [],
  //   includeGreatModTypes: [],
  //   includeGoodModTypes: [],
  //   excludeModTypes: [],
  // },
  {
    type: IdentifiedItemType.AttackWeapons,
    category: AttackWeaponsCategory.RangedPhysical,
    domain: ModDomain.Equipment,
    name: 'Ranged Physical Attack Weapons',
    tags: ['physical_damage', 'physical', 'critical', 'speed', 'attack'],
    excludeTags: ['caster_damage', 'caster'],
    badTags: ['chaos'],
    slots: ['bow', 'ranged', 'two_hand_weapon', 'weapon'],
    excludeSlots: [],
    includePerfectModTypes: ['LocalAddedPhysicalDamage', 'LocalIncreasedPhysicalDamagePercent', 'LocalIncreasedAttackSpeed', 'LocalCriticalStrikeChance'],
    includeGreatModTypes: ['GlobalProjectileSkillGemLevelWeapon'],
    includeGoodModTypes: ['LocalAddedFireDamageTwoHand', 'LocalAddedColdDamageTwoHand', 'LocalAddedLightningDamageTwoHand', 'WeaponElementalDamageOnTwohandWeapon', 'ManaLeechLocal', 'LifeLeechLocal'],
    excludeModTypes: ['LocalLightRadiusAndAccuracy', 'LocalIncreasedAccuracy'],
    fixedGoodMods: ['of Splintering'],
    fixedGreatMods: ['of Shards'],
    fixedPerfectMods: ['of Many']
  },
  // {
  //   type: IdentifiedItemType.AttackWeapons,
  //   category: AttackWeaponsCategory.RangedElemental,
  //   domain: ModDomain.Equipment,
  //   name: 'Ranged Elemental Attack Weapons',
  //   tags: ['elemental_damage', 'elemental', 'speed', 'critical'],
  //   excludeTags: ['caster', 'chaos'],
  //   badTags: ['physical', 'physical_damage', 'chaos'],
  //   slots: ['bow', 'ranged', 'two_hand_weapon', 'weapon'],
  //   excludeSlots: [],
  //   includeGreatModTypes: ['GlobalProjectileSkillGemLevelWeapon'],
  //   includeGoodModTypes: [],
  //   excludeModTypes: [],
  //   fixedGoodMods: ['of Splintering'],
  //   fixedGreatMods: ['of Shards', 'of Many'],
  // },
  {
    type: IdentifiedItemType.LifeArmour,
    category: LifeArmourCategory.LifeBoots,
    domain: ModDomain.Equipment,
    name: 'Life Boots',
    tags: ['speed', 'defences', 'drop', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: [],
    slots: ['boots', 'armour', 'dex_armour', 'str_armour', 'int_armour', 'str_dex_armour', 'dex_int_armour', 'str_int_armour', 'str_dex_int_armour'],
    excludeSlots: [],
    includePerfectModTypes: ['MovementVelocity'],
    includeGreatModTypes: ['IncreasedLife', 'ChaosResist'],
    includeGoodModTypes: ['Dexterity', 'Strength', 'Intelligence'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.LifeArmour,
    category: LifeArmourCategory.LifeHelmets,
    domain: ModDomain.Equipment,
    name: 'Life Helmets',
    tags: ['defences', 'drop', 'attribute', 'resistance', 'attack', 'speed'],
    excludeTags: [],
    badTags: [],
    slots: ['helmet', 'armour', 'dex_armour', 'str_armour', 'int_armour', 'str_dex_armour', 'dex_int_armour', 'str_int_armour', 'str_dex_int_armour'],
    excludeSlots: [],
    includeGreatModTypes: ['IncreasedLife', 'ChaosResist'],
    includeGoodModTypes: ['Dexterity', 'Strength', 'Intelligence'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.LifeArmour,
    category: LifeArmourCategory.LifeGloves,
    domain: ModDomain.Equipment,
    name: 'Life Gloves',
    tags: ['defences', 'drop', 'attribute', 'resistance', 'mana', 'damage', 'attack', 'elemental'],
    excludeTags: [],
    badTags: [],
    slots: ['gloves', 'armour', 'dex_armour', 'str_armour', 'int_armour', 'str_dex_armour', 'dex_int_armour', 'str_int_armour', 'str_dex_int_armour'],
    excludeSlots: [],
    includeGreatModTypes: ['IncreasedLife', 'ChaosResist'],
    includeGoodModTypes: ['Dexterity', 'Strength', 'Intelligence'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.LifeArmour,
    category: LifeArmourCategory.LifeBodyArmours,
    domain: ModDomain.Equipment,
    name: 'Life Body Armours',
    tags: ['defences', 'drop', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: [],
    slots: ['body_armour', 'armour', 'dex_armour', 'str_armour', 'int_armour', 'str_dex_armour', 'dex_int_armour', 'str_int_armour', 'str_dex_int_armour'],
    excludeSlots: [],
    includeGreatModTypes: ['IncreasedSpirit', 'IncreasedLife', 'ChaosResist'],
    includeGoodModTypes: ['Dexterity', 'Strength', 'Intelligence'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.LifeArmour,
    category: LifeArmourCategory.LifeShields,
    domain: ModDomain.Equipment,
    name: 'Life Shields',
    tags: ['block', 'ailment', 'defences', 'drop', 'attribute', 'resistance', 'physical'],
    excludeTags: [],
    badTags: [],
    slots: ['shield', 'armour', 'dex_armour', 'str_armour', 'str_dex_armour', 'dex_int_armour', 'str_int_armour', 'str_dex_int_armour', 'str_shield', 'str_int_shield', 'dex_int_shield', 'dex_shield', 'str_dex_shield'],
    excludeSlots: [],
    includeGreatModTypes: ['IncreasedLife', 'ChaosResist'],
    includeGoodModTypes: ['Dexterity', 'Strength', 'Intelligence'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.EnergyShieldArmour,
    category: EnergyShieldArmourCategory.EsBoots,
    domain: ModDomain.Equipment,
    name: 'Energy Shield Boots',
    tags: ['speed', 'energy_shield', 'defences', 'drop', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: ['life'],
    slots: ['boots', 'armour', 'int_armour', 'str_int_armour', 'dex_int_armour'],
    excludeSlots: [],
    includePerfectModTypes: ['MovementVelocity', 'LocalIncreasedEnergyShield', 'LocalIncreasedEnergyShieldPercent'],
    includeGreatModTypes: [],
    includeGoodModTypes: ['Dexterity', 'Strength'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.EnergyShieldArmour,
    category: EnergyShieldArmourCategory.EsHelmets,
    domain: ModDomain.Equipment,
    name: 'Energy Shield Helmets',
    tags: ['energy_shield', 'defences', 'drop', 'attribute', 'resistance', 'attack', 'speed'],
    excludeTags: [],
    badTags: ['life'],
    slots: ['helmet', 'armour', 'int_armour', 'dex_int_armour', 'str_int_armour'],
    excludeSlots: [],
    includePerfectModTypes: ['LocalIncreasedEnergyShield', 'LocalIncreasedEnergyShieldPercent'],
    includeGreatModTypes: [],
    includeGoodModTypes: ['Dexterity', 'Strength'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.EnergyShieldArmour,
    category: EnergyShieldArmourCategory.EsGloves,
    domain: ModDomain.Equipment,
    name: 'Energy Shield Gloves',
    tags: ['energy_shield', 'defences', 'drop', 'attribute', 'resistance', 'mana', 'attack', 'elemental', 'caster', 'caster_damage'],
    excludeTags: [],
    badTags: ['life'],
    slots: ['gloves', 'armour', 'int_armour', 'dex_int_armour', 'str_int_armour'],
    excludeSlots: [],
    includePerfectModTypes: ['LocalIncreasedEnergyShield', 'LocalIncreasedEnergyShieldPercent'],
    includeGreatModTypes: [],
    includeGoodModTypes: ['Dexterity', 'Strength'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.EnergyShieldArmour,
    category: EnergyShieldArmourCategory.EsBodyArmours,
    domain: ModDomain.Equipment,
    name: 'Energy Shield Body Armours',
    tags: ['energy_shield', 'defences', 'drop', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: ['life'],
    slots: ['body_armour', 'armour', 'int_armour', 'dex_int_armour', 'str_int_armour'],
    excludeSlots: [],
    includePerfectModTypes: ['LocalIncreasedEnergyShield', 'LocalIncreasedEnergyShieldPercent'],
    includeGreatModTypes: ['IncreasedSpirit'],
    includeGoodModTypes: ['Dexterity', 'Strength'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.EnergyShieldArmour,
    category: EnergyShieldArmourCategory.EsShields,
    domain: ModDomain.Equipment,
    name: 'Energy Shield Shields',
    tags: ['energy_shield', 'block', 'ailment', 'defences', 'drop', 'attribute', 'resistance', 'physical', 'caster', 'caster_damage', 'damage'],
    excludeTags: [],
    badTags: ['life'],
    slots: ['focus', 'shield', 'armour', 'int_armour', 'dex_int_armour', 'str_int_armour', 'str_int_shield', 'dex_int_shield'],
    excludeSlots: [],
    includePerfectModTypes: ['LocalIncreasedEnergyShield', 'LocalIncreasedEnergyShieldPercent'],
    includeGreatModTypes: [],
    includeGoodModTypes: ['Dexterity', 'Strength'],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.CasterWeapons,
    category: CasterWeaponsCategory.Fire,
    domain: ModDomain.Equipment,
    name: 'Fire Caster Weapons',
    tags: ['fire', 'damage', 'elemental_damage', 'elemental', 'speed', 'caster', 'caster_damage', 'ailment'],
    excludeTags: ['attack'],
    badTags: ['physical', 'physical_damage', 'chaos', 'lightning', 'cold'],
    slots: ['wand', 'focus', 'staff'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.CasterWeapons,
    category: CasterWeaponsCategory.Cold,
    domain: ModDomain.Equipment,
    name: 'Cold Caster Weapons',
    tags: ['cold', 'damage', 'elemental_damage', 'elemental', 'speed', 'caster', 'caster_damage', 'ailment'],
    excludeTags: ['attack'],
    badTags: ['physical', 'physical_damage', 'chaos', 'fire', 'lightning'],
    slots: ['wand', 'focus', 'staff'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.CasterWeapons,
    category: CasterWeaponsCategory.Lightning,
    domain: ModDomain.Equipment,
    name: 'Lightning Caster Weapons',
    tags: ['lightning', 'damage', 'elemental_damage', 'elemental', 'speed', 'caster', 'caster_damage', 'ailment'],
    excludeTags: ['attack'],
    badTags: ['physical', 'physical_damage', 'chaos', 'fire', 'cold'],
    slots: ['wand', 'focus', 'staff'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.CasterWeapons,
    category: CasterWeaponsCategory.Chaos,
    domain: ModDomain.Equipment,
    name: 'Chaos Caster Weapons',
    tags: ['chaos', 'damage', 'speed', 'caster', 'caster_damage'],
    excludeTags: ['attack'],
    badTags: ['physical', 'physical_damage', 'fire', 'cold', 'lightning', 'elemental', 'elemental_damage'],
    slots: ['wand', 'focus', 'staff'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.CasterWeapons,
    category: CasterWeaponsCategory.Physical,
    domain: ModDomain.Equipment,
    name: 'Physical Caster Weapons',
    tags: ['physical', 'physical_damage', 'damage', 'speed', 'caster', 'caster_damage'],
    excludeTags: ['attack'],
    badTags: ['fire', 'cold', 'lightning', 'chaos', 'elemental', 'elemental_damage'],
    slots: ['wand', 'focus', 'staff'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.CasterWeapons,
    category: CasterWeaponsCategory.Minion,
    domain: ModDomain.Equipment,
    name: 'Minion Caster Weapons',
    tags: ['minion', 'damage', 'critical', 'speed', 'life'],
    excludeTags: [],
    badTags: [],
    slots: ['sceptre'],
    excludeSlots: [],
    includePerfectModTypes: ['GlobalMinionSpellSkillGemLevelWeapon', 'NearbyAlliesAllDamage', 'LocalIncreasedSpiritPercent', 'NearbyAlliesAddedPhysicalDamage'],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.Quivers,
    category: QuiversCategory.PhysicalQuivers,
    domain: ModDomain.Equipment,
    name: 'Physical Quivers',
    tags: ['attack', 'critical', 'damage', 'physical_damage', 'physical', 'speed', 'resistance', 'life'],
    excludeTags: ['caster_damage', 'caster', 'regen'],
    badTags: ['chaos', 'resistance'],
    slots: ['quiver'],
    excludeSlots: [],
    includeGreatModTypes: ['GlobalProjectileSkillGemLevel'],
    includeGoodModTypes: ['AddedFireDamage', 'AddedColdDamage', 'AddedLightningDamage'],
    excludeModTypes: [],
  },
  // {
  //   type: IdentifiedItemType.Quivers,
  //   category: QuiversCategory.ElementalQuivers,
  //   domain: ModDomain.Equipment,
  //   name: 'Elemental Quivers',
  //   tags: ['attack', 'critical', 'damage', 'elemental_damage', 'elemental', 'speed', 'resistance', 'life'],
  //   excludeTags: ['caster_damage', 'caster', 'regen'],
  //   badTags: ['physical', 'physical_damage', 'chaos', 'resistance'],
  //   slots: ['quiver'],
  //   excludeSlots: [],
  //   includeGreatModTypes: ['GlobalProjectileSkillGemLevel'],
  //   includeGoodModTypes: [],
  //   excludeModTypes: [],
  // },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.AttackAmulets,
    domain: ModDomain.Equipment,
    name: 'Attack Amulets',
    tags: ['attack', 'damage', 'gem', 'chaos', 'critical', 'physical_damage', 'physical', 'elemental', 'elemental_damage', 'speed', 'life', 'defences', 'drop', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: ['dot_multi', 'caster_damage', 'caster'],
    slots: ['amulet'],
    excludeSlots: [],
    includeGreatModTypes: ['IncreasedSpirit', "ItemFoundRarityIncreasePrefix", "ItemFoundRarityIncreaseSuffix"],
    includeGoodModTypes: [],
    excludeModTypes: ['GlobalMinionSpellSkillGemLevel'],
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.CasterAmulets,
    domain: ModDomain.Equipment,
    name: 'Caster Amulets',
    tags: ['caster', 'caster_damage', 'caster_critical', 'caster_speed', 'life', 'mana', 'energy_shield', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: ['dot_multi', 'attack'],
    slots: ['amulet', 'genesis_tree_caster'],
    excludeSlots: [],
    includePerfectModTypes: ["GlobalSpellGemsLevel"],
    includeGreatModTypes: ['IncreasedSpirit', 'GlobalProjectileSkillGemLevel', "ItemFoundRarityIncreasePrefix", "ItemFoundRarityIncreaseSuffix"],
    includeGoodModTypes: [],
    excludeModTypes: ["Dexterity", "SpellDamageDuringManaFlaskEffect", "CastSpeedDuringManaFlaskEffect", "DamageTakenGainedAsLife", "DamageTakenGainedAsMana"],
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.MinionAmulets,
    domain: ModDomain.Equipment,
    name: 'Minion Amulets',
    tags: ['minion', 'minion_damage', 'minion_speed', 'crit', 'life', 'mana', 'energy_shield'],
    excludeTags: [],
    badTags: [],
    slots: ['amulet', 'genesis_tree_minion'],
    excludeSlots: [],
    includePerfectModTypes: ["IncreasedSpirit", "GlobalMinionSpellSkillGemLevel"], // TODO
    includeGreatModTypes: ["ItemFoundRarityIncreasePrefix", "ItemFoundRarityIncreaseSuffix"], // TODO
    includeGoodModTypes: [], // TODO
    excludeModTypes: ["Dexterity", "DamageTakenGainedAsLife", "DamageTakenGainedAsMana", "OfferingDuration"], // TODO
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.AttackRings,
    domain: ModDomain.Equipment,
    name: 'Attack Rings',
    tags: ['attack', 'damage', 'gem', 'chaos', 'critical', 'physical_damage', 'physical', 'elemental', 'elemental_damage', 'speed', 'life', 'defences', 'drop', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: ['dot_multi', 'caster_damage', 'caster'],
    slots: ['ring'],
    excludeSlots: [],
    includeGreatModTypes: ["ItemFoundRarityIncreasePrefix", "ItemFoundRarityIncreaseSuffix"],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.CasterRings,
    domain: ModDomain.Equipment,
    name: 'Caster Rings',
    tags: ['gem', 'caster', 'caster_damage', 'caster_critical', 'caster_speed', 'life', 'mana', 'energy_shield', 'attribute', 'resistance'],
    excludeTags: ['attack', 'damage'],
    badTags: ['dot_multi'],
    slots: ['ring', 'genesis_tree_caster'],
    excludeSlots: [],
    includePerfectModTypes: ["SpellCriticalStrikeChanceRing", "SpellCriticalStrikeMultiplierRing", "GlobalIncreaseSpellSkillGemLevel", "ItemFoundRarityIncreasePrefix", "ItemFoundRarityIncreaseSuffix"],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: ["Dexterity"],
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.MinionRings,
    domain: ModDomain.Equipment,
    name: 'Minion Rings',
    tags: ['gem', 'minion', 'minion_damage', 'crit', 'minion_speed', 'life', 'mana', 'resistance'],
    excludeTags: ['attack', 'damage'],
    badTags: [],
    slots: ['genesis_tree_minion', 'ring'],
    excludeSlots: [],
    includePerfectModTypes: [], // TODO
    includeGreatModTypes: ["ItemFoundRarityIncreasePrefix", "ItemFoundRarityIncreaseSuffix", "MinionCriticalStrikeMultiplierRing", "MinionCriticalStrikeChanceRing"], // TODO
    includeGoodModTypes: ["CurseEffectiveness"], // TODO
    excludeModTypes: ["Dexterity", "LightRadiusAndManaRegeneration"], // TODO
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.Belts,
    domain: ModDomain.Equipment,
    name: 'Belts',
    tags: ['energy_shield', 'life', 'mana', 'defences', 'drop', 'attribute', 'resistance'],
    excludeTags: [],
    badTags: [],
    slots: ['belt'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.CasterBelts,
    domain: ModDomain.Equipment,
    name: 'Caster Belts',
    tags: ['gem', 'caster', 'caster_damage', 'caster_critical', 'caster_speed', 'life', 'mana', 'energy_shield', 'attribute', 'resistance'],
    excludeTags: ['attack', 'damage'],
    badTags: ['dot_multi'],
    slots: ['genesis_tree_caster', 'belt'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: ["Dexterity", "BeltFlaskLifeRecoveryRate", "SpellDamageDuringManaFlaskEffect", "CastSpeedDuringManaFlaskEffect"],
  },
  {
    type: IdentifiedItemType.Jewellery,
    category: JewelleryCategory.MinionBelts,
    domain: ModDomain.Equipment,
    name: 'Minion Belts',
    tags: ['minion', 'minion_damage', 'crit', 'minion_speed', 'life', 'mana'],
    excludeTags: [],
    badTags: [],
    slots: ['genesis_tree_minion', 'belt'],
    excludeSlots: [],
    includePerfectModTypes: ["MinionGemLevelBelt"], // TODO
    includeGreatModTypes: [], // TODO
    includeGoodModTypes: [], // TODO
    excludeModTypes: ["MinionReviveSpeed", "OfferingDuration", "LightRadiusAndManaRegeneration", "Dexterity", "BeltFlaskLifeRecoveryRate"], // TODO
  },
  {
    type: IdentifiedItemType.Jewels,
    category: JewelsCategory.MeleeAttackJewels,
    domain: ModDomain.Jewel,
    name: 'Melee Jewels',
    tags: ['attack', 'damage', 'speed', 'life', 'attribute', 'energy_shield', 'resistance', 'defences', 'block'],
    excludeTags: [],
    badTags: [],
    slots: ['strjewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Combat", "Prismatic", "Clashing", "Armoured"],
    fixedGoodMods: ["Searing", "Bestial", "Sharpened", "of Regeneration", "of the Wild", "Blasting", "Shielding", "of Lengthening", "of Frenzy", "of Raging", "Flaming"],
    fixedBadMods: ["Fortuitous", "Retaliating", "of Ancestry"]
  },
  {
    type: IdentifiedItemType.Jewels,
    category: JewelsCategory.RangedAttackJewels,
    domain: ModDomain.Jewel,
    name: 'Ranged Jewels',
    tags: ['attack', 'damage', 'speed', 'life', 'attribute', 'energy_shield', 'resistance', 'defences'],
    excludeTags: [],
    badTags: [],
    slots: ['dexjewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Combat", "Prismatic", "of Deadliness", "of Demolishing", "of Alacrity", "of Speed", "Evasive"],
    fixedGoodMods: ["Perforating", "Rancorous", "Slaying", "Surging", "Archer's", "Monk's", "Spearheaded", "of Nocking", "of Reloading", "of Rapidity", "of Sequencing", "of Spearing", "of Hunting", "Bolting", "Acrimonious", "Fletching", "of Chronomancy", "of Piercing", "of Glaciers", "of Shocking", "Humming", "Jolting"],
    fixedBadMods: ["Kinship", "Kindred", "Engaging", "Retreating", "Soaring", "of Recovery", "of Targeting", "of Biding", "of Stoutness", "of Pinning", "of Pathfinding", "of Fountains", "of the Thicker", "of the Woodland", "Verdant"]
  },
  {
    type: IdentifiedItemType.Jewels,
    category: JewelsCategory.CasterJewels,
    domain: ModDomain.Jewel,
    name: 'Caster Jewels',
    tags: ['caster', 'caster_damage', 'speed', 'mana', 'life', 'attribute', 'energy_shield', 'resistance', 'defences'],
    excludeTags: [],
    badTags: [],
    slots: ['intjewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Shimmering", "Focusing", "Mystic", "of Enchanting", "of Annihilating", "of Unmaking", "Prismatic", "of Annihilation", "of Potency"],
    fixedGoodMods: ["Serene", "of Energy", "of Osmosis", "Blasting", "of Freezing", "of Shocking", "of the Wild", "Bestial", "Chilling", "Numbing", "Acrimonious", "Chaotic"],
    fixedBadMods: []
  },
  {
    type: IdentifiedItemType.Jewels,
    category: JewelsCategory.MinionJewels,
    domain: ModDomain.Jewel,
    name: 'Minion Jewels',
    tags: ['minion', 'life', 'attribute', 'energy_shield', 'resistance', 'ailment', 'defences'],
    excludeTags: [],
    badTags: [],
    slots: ['intjewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Authoritative", "of Orchestration", "of Marshalling", "of Gripping", "Shimmering"],
    fixedGoodMods: ["of Righteousness", "of Acclimatisation", "Necromantic", "Expanding", "Hexing", "Serene", "Focusing", "of Chanting", "of Continuation", "of Energy", "of Offering"],
    fixedBadMods: ["of Annihilation", "Prismatic", "Burning", "Overgrown", "Bestial", "of Potency", "of Glaciers", "of the Wild"]
  },
  {
    type: IdentifiedItemType.TimeLostJewels,
    category: TimeLostJewelsCategory.MeleeAttackTimeLostJewels,
    domain: ModDomain.TimeLostJewel,
    name: 'Melee Time-Lost Jewels',
    tags: ['attack', 'damage', 'speed', 'life', 'attribute', 'energy_shield', 'resistance', 'defences', 'block'],
    excludeTags: [],
    badTags: [],
    slots: ['radius_jewel', 'str_radius_jewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Combat", "Prismatic", "Clashing", "Armoured", "Greater", "Grand"],
    fixedGoodMods: ["Sharpened", "Bestial", "of Regeneration", "of the Wild", "Searing", "Blasting", "Shielding", "of Lengthening", "of Frenzy", "of Raging", "Flaming"],
    fixedBadMods: ["Fortuitous", "Retaliating", "of Ancestry"]
  },
  {
    type: IdentifiedItemType.TimeLostJewels,
    category: TimeLostJewelsCategory.RangedAttackTimeLostJewels,
    domain: ModDomain.TimeLostJewel,
    name: 'Ranged Time-Lost Jewels',
    tags: ['attack', 'damage', 'speed', 'life', 'attribute', 'energy_shield', 'resistance', 'defences'],
    excludeTags: [],
    badTags: [],
    slots: ['radius_jewel', 'dex_radius_jewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Combat", "Prismatic", "of Deadliness", "of Demolishing", "of Alacrity", "of Speed", "Evasive", "Grand", "Greater"],
    fixedGoodMods: ["Acrimonious", "Perforating", "Rancorous", "Slaying", "Archer's", "Monk's", "Spearheaded", "of Nocking", "of Reloading", "of Rapidity", "of Sequencing", "of Spearing", "of Hunting", "Bolting", "Fletching", "of Chronomancy", "of Piercing", "of Shocking", "Humming", "Surging", "Jolting", "of Glaciers"],
    fixedBadMods: ["Kinship", "Kindred", "Engaging", "Retreating", "of Recovery", "of Targeting", "Verdant", "of the Thicker", "of the Woodland", "of Pathfinding", "of Fountains", "of Pinning", "of Biding", "of Stoutness"]
  },
  {
    type: IdentifiedItemType.TimeLostJewels,
    category: TimeLostJewelsCategory.CasterTimeLostJewels,
    domain: ModDomain.TimeLostJewel,
    name: 'Caster Time-Lost Jewels',
    tags: ['caster', 'caster_damage', 'speed', 'mana', 'life', 'attribute', 'energy_shield', 'resistance', 'defences'],
    excludeTags: [],
    badTags: [],
    slots: ['radius_jewel', 'int_radius_jewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Shimmering", "Focusing", "Mystic", "of Enchanting", "of Annihilating", "of Unmaking", "Grand", "Greater", "Prismatic", "of Annihilation", "of Potency"],
    fixedGoodMods: ["Serene", "of Energy", "of Osmosis", "Blasting", "of Freezing", "of Shocking", "Bestial", "of the Wild", "Acrimonious", "Chaotic", "Chilling", "Numbing"],
    fixedBadMods: []
  },
  {
    type: IdentifiedItemType.TimeLostJewels,
    category: TimeLostJewelsCategory.MinionTimeLostJewels,
    domain: ModDomain.TimeLostJewel,
    name: 'Minion Time-Lost Jewels',
    tags: ['minion', 'life', 'attribute', 'energy_shield', 'resistance', 'ailment', 'defences'],
    excludeTags: [],
    badTags: [],
    slots: ['radius_jewel','int_radius_jewel'],
    excludeSlots: [],
    includeGreatModTypes: [],
    includeGoodModTypes: [],
    excludeModTypes: [],
    fixedGreatMods: ["Authoritative", "of Orchestration", "of Marshalling", "of Gripping", "Shimmering", "Grand", "Greater"],
    fixedGoodMods: ["of Righteousness", "of Acclimatisation", "Necromantic", "Expanding", "Hexing", "Serene", "Focusing", "of Chanting", "of Continuation", "of Energy", "of Offering"],
    fixedBadMods: ["of Annihilation", "Prismatic", "Burning", "Overgrown", "Bestial", "of Potency", "of Glaciers", "of the Wild"]
  }
  // Add more categories as needed
];